import { Component, OnInit } from '@angular/core';

declare const reloadCaptcha: Function;

@Component({
  selector: 'app-cps-captcha-modal',
  templateUrl: './cps-captcha-modal.component.html',
  styleUrls: ['./cps-captcha-modal.component.scss']
})
export class CpsCaptchaModalComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
    reloadCaptcha();
  }

  public executeImportantAction(): void {
  }

}
